import { env } from '@/services/dev';
import utils from '@/services/tools';
import http from '@/services/http';
import { channel } from '@/pages/work-wx/services/channel-service';

export default {
  // 查询用户信息
  userInfoQuery(params) {
    // 获取外部联系人id查询用户是否绑定
    return http
      .wwxPost(`${env.apiBase}/wwx/user_account_query`, params)
      .then((res) => {
        const { data, err } = utils.getResponseData(res);
        if (err) {
          return Promise.reject(err);
        }
        return data;
      });
  },
  // 同业订单列表查询
  userOrderBriefQuery(condition) {
    return http
      .wwxPost(`${env.apiBase}/wwx/order_brief_query`, {
        condition: condition || undefined,
        channel,
      })
      .then((res) => {
        const { data, err } = utils.getResponseData(res);
        if (err) {
          return Promise.reject(err);
        }
        return data;
      });
  },
};
